<div class="spending-snapshot-widget" [attr.data-size]="size">
    <!-- Header -->
    <div class="ai-advice-widget__header">
        <div class="ai-advice-widget__header-content">
            <div class="ai-advice-widget__title">{{ title }}</div>

            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin #editTrigger="cdkOverlayOrigin"
                    class="ai-advice-widget__icon-container">
                    <div class="ai-advice-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Spending Snapshot">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <!-- MEDIUM/HALF/FULL SIZE CONTENT -->
    <div class="widget-content" *ngIf="size !== 'small'">
        <!-- Canvas Donut Chart -->
        <div class="chart-container">
            <canvas #donutCanvas></canvas>
        </div>

        <!-- Breakdown List (only shown in medium/half/full size) -->
        <div class="breakdown-list">
            <div class="category-item" *ngFor="let category of visibleCategories">
                <div class="category-header">
                    <div class="category-name">
                        <span class="color-indicator" [style.background-color]="category.color"></span>
                        <span class="label">{{ category.label }}</span>
                    </div>
                    <div class="category-percentage">
                        <span class="percentage">{{ category.percentage }}%</span>
                    </div>
                </div>
                <div class="category-amount">{{ category.amount }}</div>
            </div>

            <!-- Others Row with View All -->
            <div class="category-item others-row">
                <div class="category-header">
                    <div class="category-name">
                        <span class="color-indicator gray"></span>
                        <span class="label">Others</span>
                    </div>
                    <span class="view-all-link" (click)="onViewAll()">View All</span>
                </div>
            </div>
        </div>
    </div>

    <!-- SMALL SIZE CONTENT (Separate Layout) -->
    <div class="small-widget-container" *ngIf="size === 'small'">
        <!-- <div class="small-widget-header">
            <div class="small-header-content">
                <div class="small-widget-title">Spending Breakdown</div>
                <div class="small-edit-icon-container" *ngIf="isEditMode" (click)="emitEditEvent($event)">
                    <div class="small-edit-icon"></div>
                </div>
            </div>
        </div> -->

        <div class="small-widget-body">
            <div class="small-chart-placeholder mb-3">
                <canvas #donutCanvas></canvas>
            </div>

            <div class="small-categories-list" #smallCategoriesList>
                <!-- Category 1: Dining -->
                <div class="small-category-row" *ngFor="let category of visibleCategories.slice(0, 3)">
                    <div class="small-category-info">
                        <div class="small-category-name-row">
                            <span class="small-color-dot" [style.background-color]="category.color"></span>
                            <span class="small-category-label">{{ category.label }}</span>
                        </div>
                        <div class="small-category-percentage-row">
                            <span class="small-percentage-text">{{ category.percentage }}%</span>
                        </div>
                    </div>
                </div>

                <!-- Others Row -->
                <div class="small-category-row">
                    <div class="small-category-info">
                        <div class="small-category-name-row">
                            <span class="small-color-dot gray"></span>
                            <span class="small-category-label">Others</span>
                        </div>
                        <div class="small-view-all-row">
                            <span class="small-view-all-link" (click)="onViewAll()">View All</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>